import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import * as _ from "lodash";
import {OrderModel} from "../../models/order.model";
import {OmsOrdersQueryModel} from "../../models/oms-orders-query.model";
import {SliceModel} from "../../../commons/angular/models/slice.model";

@Injectable({providedIn: 'root'})
export class OrdersHttpService {

  private base_url = `/oms/orders-v2`;

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  query({filter, ...params}: OmsOrdersQueryModel): Observable<SliceModel<OrderModel>> {
    return this.http.post<SliceModel<OrderModel>>(`${this.base_url}/query`, filter, {params: _.omitBy(params, _.isNil)});
  }

}
